<template>
    <span>
       <b-card no-body>
          <b-card-header>
            <b-row>
                 <b-col sm="10">
                    <h3>Desistência do Programa</h3>
                 </b-col>
            </b-row>
          </b-card-header>
          <b-card-body>
            <span v-if="perfil === 'B'">
              <h4>Nome da beneficiária: {{usuario.nome}}</h4>
              <br>
            </span>
            <p>
Tem certeza que deseja desistir de participar do Projeto Mães Unidas? Sugerimos que inicialmente converse com o tutor responsável por sua voluntária para tentar resolver a situação. Gostaríamos de incentivar sua permanência no Projeto e, por isso, estamos disponíveis para te ajudar a resolver situações que possam estar dificultando sua participação.
            </p>
            <p><b>Tutor: </b>{{informacoes.tutor}}</p>
            <p><b>E-mail: </b>{{informacoes.email}}</p>
            <p><b>Telefone: </b>{{informacoes.telefone}}</p>
          </b-card-body>
          <b-card-footer class="p-12">
            <b-button variant="primary" @click="abrirModalDesistencia"><i class="fa fa-check"></i> Ainda quero Desistir</b-button>
            <b-button variant="secondary" @click="$router.go(-1)"><i class="fa fa-mail-reply-all"></i> Voltar</b-button>
        </b-card-footer>
       </b-card>
        <b-modal title="Desistir do Programa" :hide-footer="true" v-model="modalDesfazerVinculo">
            <b-card-body>
                 <b-form>
                    <b-col v-if="perfil === 'V'" sm="12">
                      <b-form-group label="Marque um motivo abaixo...">
                        <b-form-select v-model="cancelar.motivo" :state="cancelar.motivoState" :options="motivosVoluntario" class="mb-3">
                            <option selected :value="null"> Selecione</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                     <b-col v-if="perfil === 'B'" sm="12">
                      <b-form-group label="Marque um motivo abaixo...">
                        <b-form-select v-model="cancelar.motivo" :state="cancelar.motivoState" :options="motivosBeneficiaria" class="mb-3">
                            <option selected :value="null"> Selecione</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" v-if="cancelar.mostrarmotivoTexto">
                        <b-form-group label="Justifique:">
                            <b-form-textarea id="textarea" :state="cancelar.motivoTextoState" v-model="cancelar.motivoTexto" rows="3" max-rows="6"></b-form-textarea>
                        </b-form-group>
                    </b-col>
               </b-form>
           </b-card-body>
           <b-card-footer class="p-12">
                <b-button @click="efetivarRemocao" variant="primary"><i class="fa fa-check">&nbsp;</i> Confirmar</b-button>
                <b-button @click="modalDesfazerVinculo = false" variant="secondary"><i class="fa fa-times">&nbsp;</i> Cancelar</b-button>
           </b-card-footer>
        </b-modal>

    </span>
</template>

<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

export default {
  created () {
    this.perfil = SessionStorage.get('tipoPerfil').replace(/['"]+/g, '')
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
    this.$store.dispatch('informacoesDesistencia', SessionStorage.get('usuario'))
    this.$store.dispatch('buscarMotivosDesistenciaVoluntario')
    this.$store.dispatch('buscarMotivosDesistenciaBeneficiaria')
  },
  data () {
    return {
      perfil: null,
      modalDesfazerVinculo: false,
      cancelar: {
        justificativa: null,
        justificativaState: null,
        motivo: null,
        motivoState: null,
        mostrarMotivoTexto: false,
        mostrarmotivoTexto: false,
        mostrarMotivo: false,
        motivoTexto: null,
        motivoTextoState: null,
        documento: null,
        documentoAtr: null,
        documentoAtrState: null
      }
    }
  },
  computed: {
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    motivosVoluntario () {
      return this.$store.state.atendimento.motivosDesistenciaVoluntario
    },
    motivosBeneficiaria () {
      return this.$store.state.atendimento.motivosDesistenciaBeneficiaria
    },
    informacoes () {
      return this.$store.state.usuario.informacoes
    }
  },
  watch: {
    'cancelar.motivo': function () {
      this.cancelar.motivoTexto = null
      this.cancelar.motivoTextoState = null

      if (this.perfil === 'V') {
        if (this.cancelar.motivo !== null) {
          if (parseInt(this.cancelar.motivo) === 4) {
            this.cancelar.mostrarmotivoTexto = true
          } else {
            this.cancelar.mostrarmotivoTexto = false
          }
        }
      } else if (this.perfil === 'B') {
        if (this.cancelar.motivo !== null) {
          if (parseInt(this.cancelar.motivo) === 6) {
            this.cancelar.mostrarmotivoTexto = true
          } else {
            this.cancelar.mostrarmotivoTexto = false
          }
        }
      }
    }
  },
  methods: {
    abrirModalDesistencia () {
      this.modalDesfazerVinculo = true
    },
    validarFormRemocao () {
      let valid = true

      if (!this.cancelar.motivo) {
        valid = false
        this.cancelar.motivoState = false
      } else {
        this.cancelar.motivoState = true

        if (this.perfil === 'V') {
          if (parseInt(this.cancelar.motivo) === 4) {
            if (!this.cancelar.motivoTexto) {
              valid = false
              this.cancelar.motivoTextoState = false
            } else {
              this.cancelar.motivoTextoState = true
            }
          }
        } else if (this.perfil === 'B') {
          if (parseInt(this.cancelar.motivo) === 6) {
            if (!this.cancelar.motivoTexto) {
              valid = false
              this.cancelar.motivoTextoState = false
            } else {
              this.cancelar.motivoTextoState = true
            }
          }
        }
      }

      return valid
    },
    efetivarRemocao () {
      if (this.validarFormRemocao()) {
        let data = {
          usuario_id: parseInt(SessionStorage.get('usuario')),
          motivo: parseInt(this.cancelar.motivo),
          justificativa: this.cancelar.motivoTexto,
          perfil: this.perfil
        }

        let url = null

        if (this.perfil === 'V') {
          url = 'api/usuario/desistir-voluntario'
        } else if (this.perfil === 'B') {
          url = 'api/usuario/desistir-beneficiaria'
        }

        this.loadingCancelar = true
        Vue.http.post(url, data).then(response => {
          if (response.data.success) {
            miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
            miniToastr.success('A sua desistência do programa Mães Unidas foi realizada!', 'Sucesso!', 4500)
            sessionStorage.clear()
            this.$router.push('/login')
          }
        }).catch(e => {
          let response = e.body
          this.loadingCancelar = false
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.msg, 'Ops!', 9000)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/perfil/Desistir.vue